import PropTypes from 'prop-types';
import InSituMeasureTitle from '@/modules/templates/components/TemplateDetailsInSituMeasure/InSituMeasureTitle';
import {memo, useState} from 'react';
import {List} from 'antd';
import {EditableCell} from '@/modules/templates/components/TemplateDetailsInSituMeasure/InSituMeasureDesktopView';
import classNames from 'classnames';
import styles from './index.less';
import omit from 'lodash/omit';

const InSituMeasureListItem = ({measure, handleSave, nextPlace, hasEmptyPlace, ...props}) => {
  const [activeEdition, setActiveEdition] = useState(false);

  const handleClick = () => {
    setActiveEdition(true);
  };

  return (<>
    <List.Item className='flex px-2 gap-2 justify-between' {...props}>
      <div className='flex-grow'>
        <InSituMeasureTitle measure={measure} showAddButton nextPlace={nextPlace} hasEmptyPlace={hasEmptyPlace} />
      </div>
      <div className='flex justify-end flex-grow'>
        <div
          className={classNames(styles.editableCellContainer, activeEdition ? styles.activeEdition : styles.inactiveEdition)}
          onClick={handleClick}
        >
          <EditableCell
            isMobile
            editable
            key={measure?.key}
            handleSave={handleSave}
            activeEdition={activeEdition}
            onActiveEdition={setActiveEdition}
            {...omit(measure, ['minValue', 'maxValue', 'optionKey', 'placesMeasure', 'updatedAt', 'createdAt'])}
          >
            {[undefined, measure?.record?.[measure?.dataIndex]]}
          </EditableCell>
        </div>
      </div>
    </List.Item>
  </>);
};

InSituMeasureListItem.propTypes = {
  measure: PropTypes.object,
  handleSave: PropTypes.func,
  nextPlace: PropTypes.func,
  hasEmptyPlace: PropTypes.bool
};

export default memo(InSituMeasureListItem);
